import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RoleConfigurationPageComponent} from "./role-configuration-page/role-configuration-page.component";
import {AuthModule} from "@irian-ro/auth-web-client";
import {SharedComponentsModule} from "@well/shared-components";
import {TranslateModule} from "@ngx-translate/core";
import {DialogModule} from "primeng/dialog";
import {Route, RouterModule} from "@angular/router";

const innerRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'new',
    pathMatch: 'full'
  },
  {
    path: ':op/:uuid',
    component: RoleConfigurationPageComponent
  },
  {
    path: ':op',
    component: RoleConfigurationPageComponent
  }
]

@NgModule({
  declarations: [RoleConfigurationPageComponent],
  imports: [CommonModule,
    RouterModule.forChild(innerRoutes),
    AuthModule, SharedComponentsModule, TranslateModule, DialogModule],
})
export class RolesAndUsersManagementModule {}
